import { render, staticRenderFns } from "./demand.vue?vue&type=template&id=2b069f4f&scoped=true&"
import script from "./demand.vue?vue&type=script&lang=js&"
export * from "./demand.vue?vue&type=script&lang=js&"
import style0 from "./demand.vue?vue&type=style&index=0&id=2b069f4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b069f4f",
  null
  
)

export default component.exports